import { domLoader } from "@/loader.js";

window.mobileNavigationLoaded = false;

domLoader(function () {
  if (window.mobileNavigationLoaded) {
    return;
  }
  window.mobileNavigationLoaded = true;

  const toggle = document.getElementById("mobile-nav-toggle");
  const drawer = document.getElementById("mobile-drawer");

  if (!toggle || !drawer) {
    return;
  }

  const panel = drawer.querySelector(".site-nav__panel");

  function isMobile() {
    return window.innerWidth <= 1024;
  }

  function isOpen() {
    return document.body.classList.contains("drawer-open");
  }

  // روی دسکتاپ همین المان منوی عادیِ قابل‌استفاده است؛ فقط در موبایلِ بسته باید
  // aria-hidden + inert بگیرد تا دکمه‌ها/لینک‌های داخلش از دسترس AT و tab order خارج شوند.
  function syncDrawerA11y() {
    if (!isMobile()) {
      drawer.removeAttribute("aria-hidden");
      drawer.removeAttribute("inert");
      return;
    }
    if (isOpen()) {
      drawer.setAttribute("aria-hidden", "false");
      drawer.removeAttribute("inert");
    } else {
      drawer.setAttribute("aria-hidden", "true");
      drawer.setAttribute("inert", "");
    }
  }

  function openDrawer() {
    document.body.classList.add("drawer-open");
    syncDrawerA11y();
    toggle.setAttribute("aria-expanded", "true");
    toggle.setAttribute("aria-label", "بستن منو");
    const firstFocusable = panel?.querySelector("button, a");
    window.setTimeout(() => firstFocusable?.focus(), 80);
  }

  function closeDrawer() {
    document.body.classList.remove("drawer-open");
    syncDrawerA11y();
    toggle.setAttribute("aria-expanded", "false");
    toggle.setAttribute("aria-label", "باز کردن منو");
  }

  // وضعیت اولیه (مارک‌آپ روی دسکتاپ هم aria-hidden دارد که باید اصلاح شود)
  syncDrawerA11y();

  toggle.addEventListener("click", function () {
    isOpen() ? closeDrawer() : openDrawer();
  });

  drawer.querySelectorAll("[data-drawer-close]").forEach(function (el) {
    el.addEventListener("click", closeDrawer);
  });

  drawer.querySelectorAll(".primary-nav__item.has-mega > .primary-nav__link").forEach(function (trigger) {
    trigger.addEventListener("click", function (event) {
      if (!isMobile()) {
        return;
      }

      event.preventDefault();

      const item = trigger.closest(".primary-nav__item");
      if (!item) {
        return;
      }

      const willOpen = !item.classList.contains("is-open");

      drawer.querySelectorAll(".primary-nav__item.has-mega.is-open").forEach(function (other) {
        if (other !== item) {
          other.classList.remove("is-open");
          other.querySelector(".primary-nav__link")?.setAttribute("aria-expanded", "false");
        }
      });

      item.classList.toggle("is-open", willOpen);
      trigger.setAttribute("aria-expanded", willOpen ? "true" : "false");
    });
  });

  drawer.querySelectorAll(".primary-nav a[href]").forEach(function (link) {
    link.addEventListener("click", function (event) {
      if (!isMobile()) {
        return;
      }

      if (event.target.closest(".primary-nav__item.has-mega > .primary-nav__link")) {
        return;
      }

      closeDrawer();
    });
  });

  const drawerSearch = document.getElementById("mobile-drawer-search");
  drawerSearch?.addEventListener("click", function () {
    closeDrawer();
    window.setTimeout(function () {
      if (typeof window.kingaroOpenSearch === "function") {
        window.kingaroOpenSearch();
      }
    }, 400);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && isOpen()) {
      closeDrawer();
    }
  });

  window.addEventListener("resize", function () {
    if (!isMobile() && isOpen()) {
      closeDrawer();
    }
    syncDrawerA11y();
  });
});
